<template>
  <div class="activity_box">
    <div class="activity_item" @click="toActivity(activity)">
      <div class="activity_title" v-text="activity.title"></div>
      <div class="activity_img_box">
        <div class="activity_img">
          <img :src="activity.listThumbnail" v-if="activity.listThumbnail.length > 0" alt="" />
        </div>
        <div class="activity_info">
          <span class="status not_start" v-if="activity.status == 1">活动未开始</span>
          <span class="status playing" v-else-if="activity.status == 2">正在进行</span>
          <span class="status end" v-else-if="activity.status == 3">活动结束</span>
          <span class="time">时间：{{ activity.startTime.substring(0, 10) }} —
            {{ activity.endTime.substring(0, 10) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { deepClone, getUrlParamObj } from "@/utils";
export default {
  name: "Activity",
  props: {
    activityInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      headerHidden: false, // 是否隐藏顶部
      activity: null,
    };
  },
  watch: {
    activityInfo: {
      handler(newValue, oldValue) {
        this.activity = deepClone(newValue);
      },
      deep: true,
    },
  },
  methods: {
    /* 跳转活动详情 */
    toActivity(item) {
      if (item.shareUrl.indexOf("/#/index_share?") > -1) {
        let query = getUrlParamObj(item.shareUrl);
        if (!!this.headerHidden) {
          query = Object.assign(query, { client: 1 });
        }
        this.$router.push({
          path: "/index_share",
          query: query,
        });
      }
    },
  },
  created() {
    this.activity = deepClone(this.activityInfo);
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "client")) {
      if (query.client == 1 || query.client == '1' || query.client == true || query.client == 'true') {
        this.headerHidden = true;
      }
    }
  },
};
</script>
<style scoped lang="scss">
.activity_box {
  padding-top: 15px;
  margin-bottom: 16px;
  .activity_title {
    max-height: 22.5px;
    line-height: 22.5px;
    padding: 0;
    margin-bottom: 8px;
    overflow: hidden;
    color: #1a1a1a;
    font-size: 16px;
    font-weight: normal;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .activity_img_box {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-image: url(~@/assets/images/default_pic_16_9.png);
    margin-bottom: 5px;
    overflow: hidden;
    border-radius: 5px;
    .activity_img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      img {
        object-fit: cover;
        min-width: 100%;
        min-height: 100%;
      }
    }
    .activity_info {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 38.4px;
      background-color: rgba(0, 0, 0, 0.3);
      span {
        position: relative;
        top: 50%;
        float: left;
        display: inline-block;
        transform: translateY(-50%);
        margin-left: 8px;
        color: #fff;
        font-size: 12px;
        &.status {
          padding: 2.4px 12px;
          border-radius: 12px;
        }
        &.not_start {
          background-color: #00a250;
        }
        &.playing {
          background-color: #e43732;
        }
        &.end {
          background-color: rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
}
</style>